var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"pt-1",attrs:{"items":_vm.levels,"label":"Difficulty","background-color":"grey lighten-5","dense":"","solo":"","flat":"","item-text":"name","item-value":"value","hide-details":""},model:{value:(_vm.level),callback:function ($$v) {_vm.level=$$v},expression:"level"}})
}
var staticRenderFns = []

export { render, staticRenderFns }